import IdleState from "../../../vendor_core/src/states/IdleState";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { State } from "../../../vendor_core/core/src/states/State";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import { Tween } from "../../../vendor_core/core/src/Tween";
import { Filter, Loader } from "pixi.js";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import VendorModel from '../../../vendor_core/src/model/VendorModel';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIModes, UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import VOEUIView from '../view/VOEUIView';
import App from '../../../vendor_core/core/src/App';
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import RealityCheckModel from '../../../vendor_core/core/src/model/RealityCheckModel';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';
import KeyboardManager, { Key } from '../../../vendor_core/core/src/utils/KeyboardManager';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';

export default class SaSIdleState extends IdleState {
    private shineFilter: Filter;

    public enter(): void {
        // if (!this.shineFilter) {
        //     let shineButton = ViewManager.getLayer(DefaultLayers.BetBar)
        //         .getCurrentScene().buttons.get("feature");
        //     if (shineButton) {
        //         const uniform = {
        //             position: { type: "f", value: 0 },
        //             intensity: { type: "f", value: 1 },
        //         };
        //         this.shineFilter = new Filter(
        //             null,
        //             Loader.shared.resources.shine.data,
        //             uniform
        //         );
        //         shineButton.filters = [this.shineFilter];
        //         this.startShineEffect();
        //     }
        // }

        super.enter();

      /*  Tween.delayedCall(2, ()=> {
            ReelGroup.instance.winSymbolsView.playAnimaAtReelCell(0,0,14,"win")
        })*/

       /* ViewManager.getLayer("BetBar").getCurrentScene().groups.get("btn_buy_feature").visible = false;
        let sceneMultiplier = ViewManager.getLayer("Multipliers").setScene("freespinsBN1");
        const mergeAnim = sceneMultiplier.spineAnimations.get("multi_merged");

        mergeAnim.visible = true;
        Tween.delayedCall(2, () => {
            mergeAnim.playAsync("animation");
        })*/
    }

    protected applyStateSettings() {
        if (AutoplayModel.isAutoSpinActive() && !GameModel.shouldPauseGame) {
            this.autoSpinDelayCall = Tween.delayedCall(App.config.autoSpinDelay || 0.1, () => {
                this.spinIfInAutoplay();
            })
        }

        GameModel.restoreData = null;
       // UIController.updateFields(UIUpdateEvent.All);

        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();

        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        if(VendorModel.allowSwipeSpin) {
            reelGroup.enableSwipeSpin();
        } else {
            reelGroup.disableSwipeSpin();
        }

        if (!SpinModel.inFreegames()) {
            UIController.setMode(UIModes.DEFAULT);
        } else {
            UIController.setMode(UIModes.PROMOTION_SPINS);
        }
        UIController.setState(UIStates.IDLE);

        if (GameModel.shouldPauseGame) {
            UIController.setState(UIStates.SPIN);
            this.cleanDelayCall();
        }

        if (GameModel.hasRealityCheck) {
            let timeLeft = RealityCheckModel.getTimeTillTimeLimit();

            ConsoleUtil.log("[IdleState] Reality check time left: " + timeLeft);

            if (timeLeft > 0) {
                this.realityCheckTimer = setTimeout(
                    this.forceRealityCheck.bind(this),
                    timeLeft
                );
            } else {
                this.forceRealityCheck();
            }
        }

        if (AutoplayModel.isAutoSpinActive()) {
            if (GameModel.shouldStopAutoplay) {
                GameModel.shouldStopAutoplay = false;
                AutoplayModel.setAutoSpin(0);
                this.cleanDelayCall();
            }
            if (AutoplayModel.autoSpinLimitReached) {
                UIController.toggleComponent("autoplayLimitPopup");
                CommandManager.execute(Commands.STOP_AUTOPLAY);
                CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS);
            } else {
                UIController.setMode(UIModes.AUTO);
                UIController.setState(UIStates.IDLE);
                return;
            }
        }

        KeyboardManager.onKey("pressed", Key.SPACE, this.spinWithKey, this);
    }

    private startShineEffect() {
        if (this.shineFilter) {
            Tween.to(this.shineFilter.uniforms, 1.30, {
                position: 2,
                yoyo: false,
                repeat: 2,
                delay: 0.05,
                onComplete: () => {
                    Tween.killTweensOf(this.shineFilter.uniforms);
                }
            });

            Tween.to(this.shineFilter.uniforms, 0.5, {
                intensity: 0.85
            });
        }
    }

    public exit(): void {
        if (this.shineFilter) {
            Tween.killTweensOf(this.shineFilter.uniforms);
        }
        super.exit();
    }

}
